/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, October 25th 2022, 9:29:52 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { APISERVICEPATHS } from "lib/api";
import { FormField } from "lib/schemas";
import { QueryParameters } from "lib/types";
import { FormIcon } from "theme/icons";
import { COLORSCHEME } from "theme/styles";
import { APIMany2OneSelectFormInput, ConcreteAPIMany2OneSelectFormInputProps } from "ui-widgets";

interface FieldMany2OnePickerProps<TPrimaryObject>
  extends ConcreteAPIMany2OneSelectFormInputProps<TPrimaryObject, FormField> {
  apiQueryParams?: QueryParameters<FormField>;
  showFormInLabel?: boolean;
}

export const FieldMany2OnePicker = <TPrimaryObject,>(props: FieldMany2OnePickerProps<TPrimaryObject>) => {
  return (
    <APIMany2OneSelectFormInput<TPrimaryObject, FormField>
      label={props.label ?? "Field"}
      itemIdProperty="id"
      getOptionLabel={(option) =>
        props.showFormInLabel && option?.form_title ? `${option.label} / Form - ${option.form_title}` : option.label
      }
      loadingText="Loading Fields"
      apiServicePath={APISERVICEPATHS.formFields}
      inputStartAdornment={<FormIcon fill={COLORSCHEME.primary} width={20} height={20} />}
      {...props}
    />
  );
};
